//FUNCIONS
import React, { useCallback, useEffect, useState } from 'react';
import { StoreState } from '../../../store/createStore';
import { useDispatch, useSelector } from 'react-redux';
import {
  addressesSelectedRequest,
  btnNextCheckout,
  findShippingValue,
  setMessageToast,
  addressesEditRequest,
  storeSelectedRequest,
  viewModal,
} from '../../../store/modules/parameter/actions';
import { checkoutSetShippingPrice } from '../../../store/modules/checkout/actions';

//HOOKS
import { AddressSelectedProps, useCheckoutInfo } from '../../../hooks/useCheckoutInfo';
import { useTranslation } from '../../../hooks/useTranslation';
import { useToast } from '../../../hooks/toast';

//TYPES
import { UserAddresses } from '../../../store/modules/auth/types';

//COMPONENTS
import VerifyCustomerCard from './VerifyCustomer';
import CreateCustomer from './CreateCustomer';
import AddressCustomer from '../../../components/AddressCustomer';
import Button from '../../../components/Button';

//STYLES
import {
  ContainerSectionRequest,
  ContainerSectionLeft,
  ContainerAddress,
  ContainerAddressList,
  ContainerAddressRowHeader,
  AddressCreatedButton,
  ContainerProducts,
  ContainerSectionRight,
  ContainerDataRequest,
  ContainerDataRequestItem,
  // ContainerShippingItem,
  ContainerDataDelivery,
  ContainerDataDeliveryItem,
  ButtonShipping,
  ContainerDataStore,
  ContainerStore,
} from './styles';
import Loading from '../../../components/Loading';
import { AddressStoreSelected } from './AddressStoreCheckout/AddressStoreSelect';
import ApplyCoupon from './ApplyCoupon';
import ShippingOptions from './ShippingOptions';
import StoreAddressCard from './StoreAddressCard';
import { ProductViewNotAllow } from '../NChkProductsList/ProductViewNowAllow';
import { ProductView } from '../NChkProductsList/productView';
import MultiStore from '../../../components/Multistore';
import { CheckoutTotals } from '../components/CheckoutTotals';
import { RoundHelper } from '../../../utils/roundHelper';
import { config } from '../../../config';

const ViewCheckout: React.FC = () => {
  const [createdAddress, setCreatedAddress] = useState(false); // default:false
  const [selShippingStore, setSelShippingStore] = useState(true); // default:false
  const [shippingPriceText, setShippingPriceText] = useState(''); // default:''
  const [serviceTotals, setServiceTotals] = useState(0);
  // const [shippingPriceValue, setShippingPriceValue] = useState(0); // default:0
  const { checkout, loading: loadingCheckout, shipping } = useSelector(
    (state: StoreState) => state.checkout,
  );
  const { isSignedIn, user } = useSelector(
    (state: StoreState) => state.auth,
  );
  const {
    loading,
    address,
    store,
    locker,
    selectedShippingOption,
    multistoreSelected
  } = useSelector(
    (state: StoreState) => state.parameter,
  );
  const {
    selShipping,
    onSetSelShipping,
    onSetaddressSelect,
    addressSelected,
    createCustomer,
    onSetCreateCustomer,
    customerIsSignedIn,
    onSetCustomerIsSignedIn,
  } = useCheckoutInfo();
  const { onTranslation: t } = useTranslation();
  const dispatch = useDispatch();
  const { onSetMessage } = useToast();

  const handleadSelectShipping = useCallback(
    async (address: UserAddresses) => {
      if (address.id === undefined) {
        onSetSelShipping(true);
        setSelShippingStore(false);
        setCreatedAddress(false);
        onSetaddressSelect({} as AddressSelectedProps);
        dispatch(addressesEditRequest({} as UserAddresses));
        //dispatch(addresssAll());
      } else {
        dispatch(addressesSelectedRequest(address, false));
        onSetaddressSelect({ id: address.id, type: 'addressUser' });
        if (address.postcode) {
          dispatch(findShippingValue('shipment', address, onSetaddressSelect));
        }

        onSetSelShipping(true);
        setCreatedAddress(false);
      }
    },
    [dispatch, onSetSelShipping, onSetaddressSelect],
  );

  const handleadCreatedShipping = useCallback(async () => {
    if (isSignedIn === false) {
      await dispatch(setMessageToast({
        type: 'error', message: t('main.messages_toast.login')
      }));
      return;
    }
    setCreatedAddress(!createdAddress);
    dispatch(addressesEditRequest({} as UserAddresses));
  }, [createdAddress, isSignedIn, dispatch, t]);

  const handleadSelectedShippingStore = useCallback(() => {
    if (multistoreSelected.store_id) {
      dispatch(storeSelectedRequest(multistoreSelected));
      onSetaddressSelect({ id: multistoreSelected.store_id, type: 'addressStore' });
      onSetSelShipping(true);
    } else {
      onSetSelShipping(false, true);
      setSelShippingStore(v => !v);
    }
  }, [onSetSelShipping, multistoreSelected, dispatch, onSetaddressSelect]);

  // useEffect(() => {
  //   const setMessage = async () => {
  //     if (error === true && errorData && errorData.message !== '') {
  //       onSetMessage({ type: 'error', description: errorData.message });
  //       onSetCreateCustomer(1);
  //     }
  //   };
  //   setMessage();
  // }, [error, errorData, onSetCreateCustomer, onSetMessage]);

  // useEffect(() => {
  //   if(isSignedIn===false) {
  //     setShippingPriceText('');
  //   }
  // }, [isSignedIn, ]);

  useEffect(() => {
    const functionasync = async () => {
      if (
        checkout.customer &&
        checkout.customer.message &&
        checkout.customer.message !== ''
      ) {
        onSetMessage({
          type: 'success',
          description: checkout.customer.message,
        });
      }
    };
    functionasync();
  }, [checkout.customer, dispatch, onSetMessage]);

  useEffect(() => {
    if (user.data.seller === 1) {
      onSetCustomerIsSignedIn(true);
    } else {
      onSetCustomerIsSignedIn(false);
    }
  }, [user.data.seller, onSetCustomerIsSignedIn]);

  useEffect(() => {
    dispatch(btnNextCheckout());
  }, [dispatch]);

  useEffect(() => {
    if (selShipping) {
      return;
    }

    if (loading && addressSelected.type === 'addressUser') {
      setShippingPriceText('Calculando');
      return;
      //dispatch(checkoutSetShippingPrice(0));
    }
    if (!loading
      && addressSelected.type === 'addressUser'
      && (address && !address.shipping)
    ) {
      setShippingPriceText('---');
      return;
    }

    if (address && address.shipping && address.shipping.price) {
      setShippingPriceText(RoundHelper.toFormatted(address.shipping.price));
      dispatch(checkoutSetShippingPrice(address.shipping.price));
    }

    if (address
      && selectedShippingOption?.is_scheduled
      && !selectedShippingOption.chosen_shipping_date) {
      setShippingPriceText('---');
      return;
    }

    if (addressSelected.type !== 'addressUser') {
      setShippingPriceText('Grátis');
      dispatch(checkoutSetShippingPrice(0));
    }
    if ((store && store.store_id > 0) || (locker && locker.id)) {
      setShippingPriceText('Grátis');
      dispatch(checkoutSetShippingPrice(0));
    }
  }, [
    selectedShippingOption,
    address,
    store,
    locker,
    selShipping,
    loading,
    addressSelected,
    dispatch]);

  useEffect(() => {
    onSetSelShipping(false, false);
    setSelShippingStore(false);
  }, [store, onSetSelShipping, addressSelected]);

  useEffect(() => {
    if (checkout.services)
      checkout.services.map(service => {
        setServiceTotals(
          lastvalue => lastvalue + Number(service.service.service_price),
        );
        return service;
      });
  }, [checkout.services]);

  return (
    <>
      <ContainerSectionRequest>
        <ContainerSectionLeft enableMaxHeight={!selShipping}>
          {createCustomer > 0 ? (
            <CreateCustomer
              onSetCreateCustomer={onSetCreateCustomer}
              type={createCustomer}
            />
          ) : (
            <>
              {!selShipping ? (
                <ContainerProducts>
                  {loadingCheckout ? (
                    <Loading size={160} bShowText />
                  ) : (
                    <>
                      {checkout.items &&
                        Object.values(checkout.items).map(item => {
                          if (item.is_available < 1) {
                            return <ProductViewNotAllow key={item.id} product={item} />
                          }
                          return <ProductView key={item.id} product={item} />
                        }
                        )}
                    </>
                  )}
                </ContainerProducts>
              ) : (
                <ContainerAddress>
                  <ContainerAddressList>
                    <ContainerAddressRowHeader>
                      {!selShippingStore && !createdAddress && (
                        <AddressCreatedButton>
                          <Button
                            button={{ type: 'button', id: "button-action-new-address" }}
                            onClick={handleadCreatedShipping}
                            atributes={{
                              buttonType: 'outline',
                              borderColor: 'var(--primary)',
                              textColor: '#000',
                              marginLeft: 'auto',
                              background: '#FFF',
                              padding: '0.5rem 1rem',
                              disableWitdthfixed: true,
                            }}
                          >
                            {t('main.new_checkout.view_checkout.new_address')}
                          </Button>
                        </AddressCreatedButton>
                      )}
                      {createdAddress === false && (
                        <AddressCreatedButton>
                          <Button
                            button={{ type: 'button', id: "button-action-address-store" }}
                            onClick={handleadSelectedShippingStore}
                            atributes={{
                              buttonType: 'outline',
                              borderColor: 'var(--primary)',
                              textColor: '#000',
                              marginLeft: 'auto',
                              background: '#FFF',
                              padding: '0.5rem 1rem',
                              disableWitdthfixed: true,
                            }}
                          >
                            {!selShippingStore ? (
                              <>
                                {t(
                                  'main.new_checkout.view_checkout.pick_up_at_the_store',
                                )}
                              </>
                            ) : (
                              <>
                                {t(
                                  'main.new_checkout.view_checkout.my_address',
                                )}
                              </>
                            )}
                          </Button>
                        </AddressCreatedButton>
                      )}
                    </ContainerAddressRowHeader>
                    {!selShippingStore ? (
                      <AddressCustomer
                        createdAddress={createdAddress}
                        setCreatedAddress={setCreatedAddress}
                        handleadSelectShipping={handleadSelectShipping}
                        customerIsSignedIn={customerIsSignedIn}
                        bCheckout
                      />
                    ) : (
                      <AddressStoreSelected />
                    )}
                  </ContainerAddressList>
                  <ButtonShipping>
                    <Button
                      button={{ type: 'button' }}
                      onClick={() =>
                        handleadSelectShipping({} as UserAddresses)
                      }
                      atributes={{
                        buttonType: 'outline',
                        borderColor: 'var(--primary)',
                        textColor: '#000',
                        marginLeft: 'auto',
                        background: '#FFF',
                        textSize: '16px',
                        disableWitdthfixed: true,
                      }}
                    >
                      {t('main.globals.cancel')}
                    </Button>
                  </ButtonShipping>
                </ContainerAddress>
              )}
            </>
          )}
        </ContainerSectionLeft>
        <ContainerSectionRight>
          <ContainerDataRequest>
            {loadingCheckout ? (
              <Loading size={160} />
            ) : (
              <>
                <ContainerDataRequestItem>
                  <h4>{t('main.new_checkout.view_checkout.order_data')}</h4>
                </ContainerDataRequestItem>
                {
                  multistoreSelected.store_id && (
                    <ContainerStore isMultiStore={config.isAllowedMultistore}>
                      <ContainerDataStore>
                        <span>{t('main.new_checkout.view_checkout.store_selected')} - {multistoreSelected.name}</span>
                        <span>
                          {multistoreSelected.address}, {multistoreSelected.number}
                          {multistoreSelected.complement && ` - ${multistoreSelected.complement}`} -{' '}
                          {multistoreSelected.neighborhood} - {multistoreSelected.city}/{multistoreSelected.state} - CEP:{' '}
                          {multistoreSelected.zip_code}
                        </span>
                      </ContainerDataStore>
                      {config.isAllowedMultistore && (<Button
                        button={{ type: 'button' }}
                        onClick={() => {
                          dispatch(viewModal(MultiStore, { width: '50%', height: '100%', buttonClose: true }, true));
                          onSetaddressSelect({} as AddressSelectedProps);
                        }}
                        atributes={{
                          buttonType: 'outline',
                          borderColor: 'var(--primary)',
                          textColor: 'var(--primary)',
                          background: 'transparent',
                          textSize: '12px',
                          disableWitdthfixed: true,
                          textColorHover: '#FFF',
                          borderColorHover: 'var(--primary)',
                        }}
                      >
                        {t('main.globals.change')}
                      </Button>)}
                    </ContainerStore>
                  )
                }
                <CheckoutTotals.Root>
                  <CheckoutTotals.SubTotal
                    title={t('main.new_checkout.view_checkout.subtotal')}
                    value={RoundHelper.toFormatted(checkout.sub_total)}
                  />
                  <CheckoutTotals.Shipping
                    title={t('main.new_checkout.view_checkout.shipping')}
                    value={addressSelected.id ? (
                      shippingPriceText
                    ) : (
                      '---'
                    )}
                  />
                  <CheckoutTotals.Services
                    title={t('main.new_checkout.view_checkout.services')}
                    value={checkout && serviceTotals}
                  />
                  {
                    Number(checkout.discount) > 0 && (
                      <CheckoutTotals.Discount
                        title={t('main.new_checkout.view_checkout.discount')}
                        value={RoundHelper.toFormatted(checkout.discount)}
                      />
                    )
                  }
                  <CheckoutTotals.Total
                    title={t('main.new_checkout.view_checkout.total')}
                    value={RoundHelper.toFormatted(RoundHelper.toNumber(checkout.grand_total) + shipping)}
                  />
                </CheckoutTotals.Root>
              </>
            )}
          </ContainerDataRequest>
          <ContainerDataDelivery>
            <ContainerDataRequestItem>
              <ApplyCoupon />
            </ContainerDataRequestItem>
          </ContainerDataDelivery>
          {addressSelected.id && addressSelected.type === 'addressUser' && (
            <ContainerDataDelivery>
              <ContainerDataRequestItem>
                <ShippingOptions
                  onShippingSelect={option => {

                  }}
                  headerButton={
                    <Button
                      button={{ type: 'button' }}
                      onClick={() => {
                        handleadSelectShipping({} as UserAddresses)
                      }
                      }
                      atributes={{
                        buttonType: 'outline',
                        borderColor: 'var(--primary)',
                        textColor: 'var(--primary)',
                        background: 'transparent',
                        textSize: '12px',
                        padding: '6px 12px',
                        disableWitdthfixed: true,
                        textColorHover: '#FFF',
                        borderColorHover: 'var(--primary)',
                      }}
                    >
                      {t('main.globals.change')}
                    </Button>
                  }
                />
              </ContainerDataRequestItem>
            </ContainerDataDelivery>
          )}
          {addressSelected.id && addressSelected.type === 'addressStore' && (
            <ContainerDataDelivery>
              <StoreAddressCard
                headerButton={
                  <Button
                    button={{ type: 'button' }}
                    onClick={() => handleadSelectShipping({} as UserAddresses)}
                    atributes={{
                      buttonType: 'outline',
                      borderColor: 'var(--primary)',
                      textColor: 'var(--primary)',
                      background: 'transparent',
                      textSize: '12px',
                      padding: '6px 12px',
                      disableWitdthfixed: true,
                      textColorHover: '#FFF',
                      borderColorHover: 'var(--primary)',
                    }}
                  >
                    {t('main.globals.change')}
                  </Button>
                }
              />
            </ContainerDataDelivery>
          )}
          {customerIsSignedIn && createCustomer === 0 && (
            <ContainerDataDelivery>
              <ContainerDataRequestItem>
                <VerifyCustomerCard onSetCreateCustomer={onSetCreateCustomer} />
              </ContainerDataRequestItem>
            </ContainerDataDelivery>
          )}
          {((!selShipping && !customerIsSignedIn) ||
            (!selShipping && checkout.customer)) &&
            !createCustomer &&
            !addressSelected.id && (
              <ContainerDataDelivery>
                <ContainerDataRequestItem>
                  <ContainerDataDeliveryItem>
                    <h4>
                      {t('main.new_checkout.view_checkout.delivery_data')}
                    </h4>
                    <ButtonShipping>
                      <Button
                        button={{ type: 'button', id: "button-action-address" }}
                        onClick={() =>
                          handleadSelectShipping({} as UserAddresses)
                        }
                        atributes={{
                          buttonType: addressSelected.id
                            ? 'outline'
                            : 'primary',
                          borderColor: 'var(--primary)',
                          textColor: addressSelected.id
                            ? 'var(--primary)'
                            : '#FFF',
                          background: addressSelected.id
                            ? 'transparent'
                            : 'var(--primary)',
                          textSize: '16px',
                          padding: '12px 24px',
                          disableWitdthfixed: true,
                          textColorHover: '#FFF',
                          borderColorHover: 'var(--primary)',
                        }}
                      >
                        {addressSelected.id
                          ? t('main.globals.change')
                          : t('main.messages_toast.select_address')}
                      </Button>
                    </ButtonShipping>
                  </ContainerDataDeliveryItem>
                </ContainerDataRequestItem>
              </ContainerDataDelivery>
            )}
        </ContainerSectionRight>
      </ContainerSectionRequest>
    </>
  );
};

export default ViewCheckout;
